export default {
  ALL_SITE_PUBLISHER: "ALL_SITE_PUBLISHER",
  SPECIFIC_SITE_PUBLISHER: "SPECIFIC_SITE_PUBLISHER:",
};
